import type { ConfigResponse } from '@/api/types';
import { launchReadiness, matches12070, type LaunchPolicy } from '@/tx/launchIntent';
import './curve-feature.css';

export function CurveFeature({ config, mode }: { config: ConfigResponse & LaunchPolicy; mode?: string }) {
  if (!matches12070(config, mode)) return null;
  return <section className="curve-feature" aria-label="The 120/70 curve">
    <div className="curve-feature-intro"><span>NEW LAUNCHES</span><h2>The 120/70 curve</h2>
      {launchReadiness(config) && <p className="curve-feature-status">Launch availability pending</p>}
      <p>A flatter start. Compared with a Pump-style curve, pricing rises more gently across the public sale. Prices still move with buys and sells.</p></div>
    <dl><div><dt>Graduation target</dt><dd>120 SOL</dd></div><div><dt>Available on curve</dt><dd>70%</dd></div><div><dt>Reserved for graduated pool</dt><dd>30%</dd></div></dl>
    <p className="curve-feature-note">30% of tokens reserved for the pool at graduation; SOL raised from buyers. Existing coins keep their original curve.</p>
    <p className="curve-feature-note">Sponsored creation when available. Raydium protocol and network fees apply separately to trading.</p>
  </section>;
}
